import * as React from "react"

import { setLocalStorageUserInfo } from "../../../utils/local-storage-user-info"
import {
  formatFormValues,
  HUBSPOT_BLOCKED_EMAIL_ERROR_MESSAGE,
  legalDisbursements,
} from "../../../utils/requests/hubspot"
import { OnSubmit } from "../../form/submit-button/types"
import { trackSubmission } from "./helpers"
import { FormValues } from "./types"

export const useForm = () => {
  const [globalError, setGlobalError] = React.useState("")

  const onSubmit: OnSubmit<FormValues> = async (values, formik) => {
    setGlobalError("")
    const payload = formatFormValues(values)
    const { success, errors } = await legalDisbursements(payload)

    if (success) {
      setLocalStorageUserInfo({ email: values.email })
      trackSubmission(values)
      window.location.href = "https://meetings.hubspot.com/austin295"
    } else if (errors === HUBSPOT_BLOCKED_EMAIL_ERROR_MESSAGE) {
      formik.setErrors({ email: HUBSPOT_BLOCKED_EMAIL_ERROR_MESSAGE })
      trackSubmission(values, HUBSPOT_BLOCKED_EMAIL_ERROR_MESSAGE)
    } else {
      setGlobalError(errors ?? "")
      trackSubmission(values, errors as string)
    }
  }

  return { globalError, onSubmit }
}
